import React from "react";
import styled from "styled-components";
import { ShowDialog, ShowDialogAsync, ShowErrorDialog } from "./BaseDialog";
import { themeColors } from "js/react/sharedStyles";
import EndTrialDialog from "js/react/views/Billing/dialogs/EndTrialDialog";
import ErrorDialog from "./ErrorDialog";

const MessageBlock = styled.div`
a {
    color: ${themeColors.ui_blue};
    text-decoration: none;
    pointer-events: auto;
    cursor: pointer;
}
`;

export const ShowInsufficientCreditsDialog = (loadCreditsBalance = null) => {
    let dialog = null;
    dialog = ShowDialog(ErrorDialog, {
        title: "You don't have enough credits.",
        message: (
            <>
                <MessageBlock>
                    Credits are used to create AI generated slides from added context (1 credit) and images (2 credits). Once your trial ends and your subscription starts, access to these features will be free of charge.
                </MessageBlock>
                <br />
                <MessageBlock>
                    <a onClick={async () => {
                        const result = await ShowDialogAsync(EndTrialDialog);
                        if (result) {
                            loadCreditsBalance && loadCreditsBalance();
                            dialog.close();
                        }
                    }}>Start your subscription now</a> for continued access to these features.
                </MessageBlock>
            </>
        ),
        acceptButtonText: "Got It",
        icon: "/images/bai-bot/bai-bot-neutral.svg",
    });
};

export const ShowTooManyRequestsDialog = () => {
    ShowErrorDialog({
        title: "Daily limit reached",
        message: "To keep generation fast and reliable for everyone, limits reset every 24 hours. You can start creating again tomorrow.",
        acceptButtonText: "Got It",
        icon: "/images/bai-bot/bai-bot-sad.png"
    });
};
